var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.5,
    height: 63.596,
    viewBox: "0 0 73.5 63.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(575 -34.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M-505.95,43.042h-3.23V37.8a3.305,3.305,0,0,0-3.3-3.3H-514.8a3.305,3.305,0,0,0-3.3,3.3v5.244h-7.487V37.8a3.305,3.305,0,0,0-3.3-3.3H-531.2a3.306,3.306,0,0,0-3.3,3.3v5.244h-7.487V37.8a3.306,3.306,0,0,0-3.3-3.3h-2.315a3.306,3.306,0,0,0-3.3,3.3v5.244H-558.4V37.8a3.306,3.306,0,0,0-3.3-3.3h-2.316a3.306,3.306,0,0,0-3.3,3.3v5.244h-3.23a4.455,4.455,0,0,0-4.45,4.45V94.216a3.881,3.881,0,0,0,3.876,3.876h65.748a3.881,3.881,0,0,0,3.876-3.876V47.492A4.455,4.455,0,0,0-505.95,43.042ZM-516.09,37.8a1.294,1.294,0,0,1,1.292-1.292h2.316A1.294,1.294,0,0,1-511.19,37.8v5.244h-4.9Zm-16.407,0a1.294,1.294,0,0,1,1.292-1.292h2.315A1.294,1.294,0,0,1-527.6,37.8v5.244h-4.9Zm-16.407,0a1.294,1.294,0,0,1,1.292-1.292h2.316A1.294,1.294,0,0,1-544,37.8v5.244h-4.9Zm-16.407,0a1.294,1.294,0,0,1,1.292-1.292h2.316A1.294,1.294,0,0,1-560.41,37.8v5.244h-4.9Zm-7.68,9.695a2.443,2.443,0,0,1,2.44-2.44h64.6a2.443,2.443,0,0,1,2.44,2.44v6.533h-69.48Zm69.48,46.724a1.869,1.869,0,0,1-1.866,1.866h-65.748a1.869,1.869,0,0,1-1.866-1.866V56.036h69.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M-532.847,219.4h6.165a2.156,2.156,0,0,0,2.153-2.153v-4.552a2.156,2.156,0,0,0-2.153-2.153h-6.165A2.156,2.156,0,0,0-535,212.693v4.552A2.156,2.156,0,0,0-532.847,219.4Zm-.144-6.706a.144.144,0,0,1,.144-.144h6.165a.144.144,0,0,1,.144.144v4.552a.144.144,0,0,1-.144.144h-6.165a.144.144,0,0,1-.144-.144Z",
    transform: "translate(-34.258 -150.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M-413.163,219.4H-407a2.156,2.156,0,0,0,2.153-2.153v-4.552A2.156,2.156,0,0,0-407,210.54h-6.165a2.156,2.156,0,0,0-2.153,2.153v4.552A2.156,2.156,0,0,0-413.163,219.4Zm-.144-6.706a.144.144,0,0,1,.144-.144H-407a.144.144,0,0,1,.144.144v4.552a.144.144,0,0,1-.144.144h-6.165a.144.144,0,0,1-.144-.144Z",
    transform: "translate(-136.761 -150.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M-293.475,219.4h6.165a2.156,2.156,0,0,0,2.153-2.153v-4.552a2.156,2.156,0,0,0-2.153-2.153h-6.165a2.156,2.156,0,0,0-2.153,2.153v4.552A2.156,2.156,0,0,0-293.475,219.4Zm-.144-6.706a.144.144,0,0,1,.144-.144h6.165a.144.144,0,0,1,.144.144v4.552a.144.144,0,0,1-.144.144h-6.165a.144.144,0,0,1-.144-.144Z",
    transform: "translate(-239.267 -150.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M-173.791,219.4h6.165a2.156,2.156,0,0,0,2.153-2.153v-4.552a2.156,2.156,0,0,0-2.153-2.153h-6.165a2.156,2.156,0,0,0-2.153,2.153v4.552A2.156,2.156,0,0,0-173.791,219.4Zm-.144-6.706a.144.144,0,0,1,.144-.144h6.165a.144.144,0,0,1,.144.144v4.552a.144.144,0,0,1-.144.144h-6.165a.144.144,0,0,1-.144-.144Z",
    transform: "translate(-341.77 -150.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M-532.847,302.023h6.165a2.156,2.156,0,0,0,2.153-2.153v-4.552a2.156,2.156,0,0,0-2.153-2.153h-6.165A2.156,2.156,0,0,0-535,295.317v4.552A2.156,2.156,0,0,0-532.847,302.023Zm-.144-6.706a.144.144,0,0,1,.144-.144h6.165a.144.144,0,0,1,.144.144v4.552a.144.144,0,0,1-.144.144h-6.165a.144.144,0,0,1-.144-.144Z",
    transform: "translate(-34.258 -221.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21",
    "data-name": "Trazado 21",
    d: "M-413.163,302.023H-407a2.156,2.156,0,0,0,2.153-2.153v-4.552A2.156,2.156,0,0,0-407,293.164h-6.165a2.156,2.156,0,0,0-2.153,2.153v4.552A2.156,2.156,0,0,0-413.163,302.023Zm-.144-6.706a.144.144,0,0,1,.144-.144H-407a.144.144,0,0,1,.144.144v4.552a.144.144,0,0,1-.144.144h-6.165a.144.144,0,0,1-.144-.144Z",
    transform: "translate(-136.761 -221.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22",
    "data-name": "Trazado 22",
    d: "M-293.475,302.023h6.165a2.156,2.156,0,0,0,2.153-2.153v-4.552a2.156,2.156,0,0,0-2.153-2.153h-6.165a2.156,2.156,0,0,0-2.153,2.153v4.552A2.156,2.156,0,0,0-293.475,302.023Zm-.144-6.706a.144.144,0,0,1,.144-.144h6.165a.144.144,0,0,1,.144.144v4.552a.144.144,0,0,1-.144.144h-6.165a.144.144,0,0,1-.144-.144Z",
    transform: "translate(-239.267 -221.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M-173.791,302.023h6.165a2.156,2.156,0,0,0,2.153-2.153v-4.552a2.156,2.156,0,0,0-2.153-2.153h-6.165a2.156,2.156,0,0,0-2.153,2.153v4.552A2.156,2.156,0,0,0-173.791,302.023Zm-.144-6.706a.144.144,0,0,1,.144-.144h6.165a.144.144,0,0,1,.144.144v4.552a.144.144,0,0,1-.144.144h-6.165a.144.144,0,0,1-.144-.144Z",
    transform: "translate(-341.77 -221.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24",
    "data-name": "Trazado 24",
    d: "M-532.847,384.658h6.165a2.156,2.156,0,0,0,2.153-2.153v-4.551a2.156,2.156,0,0,0-2.153-2.153h-6.165A2.156,2.156,0,0,0-535,377.953v4.552A2.156,2.156,0,0,0-532.847,384.658Zm-.144-6.7a.144.144,0,0,1,.144-.144h6.165a.144.144,0,0,1,.144.144v4.552a.144.144,0,0,1-.144.144h-6.165a.144.144,0,0,1-.144-.144Z",
    transform: "translate(-34.258 -292.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M-413.163,384.658H-407a2.156,2.156,0,0,0,2.153-2.153v-4.551A2.156,2.156,0,0,0-407,375.8h-6.165a2.156,2.156,0,0,0-2.153,2.153v4.552A2.156,2.156,0,0,0-413.163,384.658Zm-.144-6.7a.144.144,0,0,1,.144-.144H-407a.144.144,0,0,1,.144.144v4.552a.144.144,0,0,1-.144.144h-6.165a.144.144,0,0,1-.144-.144Z",
    transform: "translate(-136.761 -292.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M-285.883,378.388a1,1,0,0,0-1.409.188l-4.192,5.48-2.354-2.973a1,1,0,0,0-1.411-.163,1,1,0,0,0-.163,1.411l3.158,3.985a1,1,0,0,0,.787.381h.009a1.007,1.007,0,0,0,.79-.395l4.973-6.506a1,1,0,0,0-.186-1.408Z",
    transform: "translate(-239.266 -294.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M-166.179,378.388a1,1,0,0,0-1.409.188l-4.188,5.48-2.354-2.973a1,1,0,0,0-1.411-.163,1,1,0,0,0-.163,1.411l3.158,3.985a1.006,1.006,0,0,0,.788.381h.009a1.007,1.007,0,0,0,.79-.395l4.972-6.506a1,1,0,0,0-.19-1.408Z",
    transform: "translate(-341.789 -294.348)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c73b7af4146c564c96e17275c232a0b0.svg";
export { ForwardRef as ReactComponent };